import React, { useState } from "react";
import {
  Button,
  DropdownMenu,
  NewTab,
  PageHeader,
  PageTab,
  PageTitle,
} from "../../../components";
import UpcomingPaydays from "./Payroll/UpcomingPaydays";
import PastPaydays from "./Payroll/PastPaydays";
import OffCyclePayData from "./Payroll/OffCyclePayData";
import { useNavigate } from "react-router-dom";
import AddOffCycle from "./Payroll/Modals/AddOffCycle";
import PayrollSummary from "./Payroll/PayrollSummary";
import Summary from "./Payroll/Summary";

const Payroll = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const PayrollMenus = [
    {
      title: "Payroll Summary",
      page: <Summary />,
      type: "main",
    },
    {
      title: "Upcoming Paydays",
      page: <UpcomingPaydays />,
      type: "main",
    },

    {
      title: "Past Paydays",
      page: <PastPaydays />,
      type: "main",
    },
    {
      title: "Off-Cycle Pay Data",
      page: <OffCyclePayData />,
      type: "main",
      subTabs: [
        {
          title: "Add Pay Cycle",
          icon: "add",
          action: handleOpenModal,
        },
      ],
    },
    {
      title: "Payroll Reconcilations",
      page: <PayrollSummary />,
      type: "main",
    },
  ];

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <PageHeader
        Section={
          <div className="flex my-3">
            <PageTitle title={"Payroll Management"} tag="h5" />
          </div>
        }
        RightSection={
          <>
            {/* <Button
              title="Pay Data Center"
              size="sm"
              onClick={() => navigate("/payroll/pay-data-center")}
            /> */}
            <Button
              title="Salary Profile Configarations"
              size="sm"
              icon={"settings"}
              onClick={() => navigate("/payroll/salary-profile-configaration")}
            />

            {/* <DropdownMenu
              MenuSection={
                <div className="flex flex-col">
                  <Button
                    title={"Salary Profile Configarations"}
                    variant="text"
                    color="black"
                    size="xs-sm"
                    className="!justify-start py-1"
                    onClick={() =>
                      navigate("/payroll/salary-profile-configaration")
                    }
                  />
                  
                </div>
              }
            >
              <Button color="black" title="" size="sm" icon={"settings"} />
            </DropdownMenu> */}
          </>
        }
      />
      <div className="flex-1 flex flex-col overflow-hidden">
        <NewTab
          tabs={PayrollMenus}
          color="black"
          variant="outlined"
          tabLevel="employees"
          mode="url"
          tabId="payroll"
        />
      </div>
      <AddOffCycle isOpen={isModalOpen} onClose={handleCloseModal} />
    </div>
  );
};

export default Payroll;
